import React, { useEffect } from "react";

const GoogleTranslate = () => {

  const googleTranslateElementInit = () => {
    if (!window.google || !window.google.translate) return;

    new window.google.translate.TranslateElement(
      {
        pageLanguage: "mn",
        includedLanguages: "zh-CN,mn,en",
        autoDisplay: false,
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
      },
      "google_translate_element"
    );
  };

  useEffect(() => {

    const loadTranslator = () => {

      // wait extra time so APIs render first
      setTimeout(() => {

        if (!window.googleTranslateScriptLoaded) {

          const script = document.createElement("script");
          script.src =
            "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

          document.body.appendChild(script);

          window.googleTranslateElementInit = googleTranslateElementInit;
          window.googleTranslateScriptLoaded = true;

        } else {
          googleTranslateElementInit();
        }

      }, 2000); // wait 2 seconds after page load

    };

    if (document.readyState === "complete") {
      loadTranslator();
    } else {
      window.addEventListener("load", loadTranslator);
    }

  }, []);

  return <div id="google_translate_element" className="select_language"></div>;
};

export default GoogleTranslate;